import styled from 'styled-components';
import { StyledGridRow } from 'ui/indexPages/tables/grid';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  destination: pxToRem(280),
  status: pxToRem(100),
  sync: pxToRem(350),
  modified: pxToRem(150),
};

export const HeaderGridRow = styled(StyledGridRow)`
  border-bottom: solid ${spacing.single} ${colors.grey15};
  padding: 0 ${spacing.double};
  gap: 0;

  button {
    padding-left: ${spacing.base};
    padding-right: ${spacing.base};
  }

  button:first-child {
    padding-left: 0;
  }

  button:last-child {
    padding-right: 0;
  }
`;

export const DESTINATION_COLUMN_GRID = `
  minmax(${customSpacing.destination}, 2fr) // Destination
  minmax(${customSpacing.status}, auto) // Status 
  minmax(${customSpacing.sync}, 1.5fr) // Last successful sync
  minmax(${customSpacing.modified}, 1fr) // Last modified
`;
